<fieldset>
  <div id="{{ createAttributeIdForConfigurator(attribute) }}">
    <ng-container
      *ngIf="
        attribute.values && attribute.values.length > 0;
        else noStaticDomain
      "
    >
      <ng-container *ngFor="let value of attribute.values">
        <div
          *ngIf="value.selected && (changedPrices$ | async) as changedPrices"
          class="form-check"
        >
          <span
            id="{{
              createValueUiKey('aria-label', attribute.name, value.valueCode)
            }}"
            role="note"
            tabindex="0"
            class="cx-visually-hidden"
          >
            {{
              getAriaLabel(
                attribute,
                enrichValueWithPrice(value, changedPrices)
              )
            }}
          </span>
          <div class="cx-value-label-pair">
            <label
              id="{{
                createValueUiKey('label', attribute.name, value.valueCode)
              }}"
              aria-hidden="true"
              class="cx-read-only-attribute-label"
              ><b>{{ value.valueCode }}</b>
              {{ ' : ' + value.valueDisplay }}</label
            >
            <cx-configurator-show-more
              *ngIf="value.description"
              [text]="value.description"
              [textSize]="getValueDescriptionLength()"
              [productName]="
                getLabel(expMode, value.valueDisplay, value.valueCode)
              "
              [tabIndex]="0"
            ></cx-configurator-show-more>
          </div>
          <div class="cx-value-price">
            <cx-configurator-price
              [formula]="
                extractValuePriceFormulaParameters(
                  enrichValueWithPrice(value, changedPrices)
                )
              "
            ></cx-configurator-price>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #noStaticDomain>
      <ng-container *ngIf="attribute.selectedSingleValue">
        <span
          id="{{
            createValueUiKey(
              'aria-label',
              attribute.name,
              attribute.selectedSingleValue
            )
          }}"
          role="note"
          tabindex="0"
          class="cx-visually-hidden"
        >
          {{ getAriaLabel(attribute) }}
        </span>
        <div class="cx-read-only-attribute-label" aria-hidden="true">
          <span aria-hidden="true">{{ attribute.selectedSingleValue }}</span>
        </div>
      </ng-container>
      <ng-container *ngIf="attribute.userInput">
        <span
          id="{{
            createValueUiKey('aria-label', attribute.name, attribute.userInput)
          }}"
          role="note"
          tabindex="0"
          class="cx-visually-hidden"
        >
          {{ getAriaLabel(attribute) }}
        </span>
        <div class="cx-read-only-attribute-label" aria-hidden="true">
          <span aria-hidden="true">{{ attribute.userInput }}</span>
        </div>
      </ng-container>
    </ng-template>
  </div>
</fieldset>
